import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'persianNumber',
})
export class PersianNumberPipe implements PipeTransform {

  // Converts English numbers to Persian numbers
  public static convertToPersianNumber(value: string): string {
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return value.replace(/[0-9]/g, (i) => persianNumbers[+i]);
  }

  // Converts Persian numbers to English numbers
  public static convertToEnglishNumber(value: string): string {
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];  // Define Persian numbers array here
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];  // Define English numbers array here
    return value.replace(/[۰-۹]/g, (i) => englishNumbers[persianNumbers.indexOf(i)]);
  }

  transform(value: string | number, convertToPersian: boolean = true): string {
    const valueString = value?.toString();
    if (valueString) {
      if (convertToPersian) {
        return PersianNumberPipe.convertToPersianNumber(valueString);
      } else {
        return PersianNumberPipe.convertToEnglishNumber(valueString);
      }
    }
    return '';
  }
}
